import { Suspense } from "react"
import { Dialog, Loader } from "@tm/components"
import { useUserSettingsStore } from "../../user-settings/business"
import UserSettings from "../../user-settings/component"

export function UserSettingsDialog() {
    const { openUserSettings, setOpen } = useUserSettingsStore((userSettingsStore) => ({
        openUserSettings: userSettingsStore.state.openUserSettings,
        setOpen: userSettingsStore.actions.setOpenOrToggleUserSettings,
    }))

    if (!openUserSettings) {
        return null
    }

    return (
        <Dialog
            open={openUserSettings}
            PaperProps={{ sx: { overflow: "hidden", "& > div": { padding: 0 } } }}
            fullWidth
            maxWidth={false}
            onOutsideClick={() => setOpen(false)}
        >
            <Suspense fallback={<Loader />}>
                <UserSettings />
            </Suspense>
        </Dialog>
    )
}
